import React, { useEffect, useState } from 'react';
import { CheckCircle, Home, Receipt, ChevronRight, Copy } from 'lucide-react';

const PaymentSuccessPage = () => {
    // 실제로는 URL query param이나 전역 상태에서 결제 정보를 가져와야 합니다.
    // 예시를 위해 Mock Data를 사용합니다.
    const [orderInfo, setOrderInfo] = useState(null);

    useEffect(() => {
        // API 호출 또는 데이터 로딩 시뮬레이션
        setTimeout(() => {
            setOrderInfo({
                orderId: "ORD_20240115_AB1234",
                date: "2024. 01. 15. 14:30",
                items: [
                    { name: "차돌숙주짬뽕", quantity: 2, price: 22000 },
                    { name: "아차산더미 숙주탕수육 (소)", quantity: 1, price: 21000 }
                ],
                totalAmount: 43000,
                usedPoints: 3000, // 포인트 사용액
                finalAmount: 40000,
                paymentMethod: "토스페이먼츠 (카드)"
            });
        }, 500);
    }, []);

    if (!orderInfo) {
        return (
            <div className="min-h-screen bg-gray-100 flex justify-center items-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-100 flex justify-center font-sans text-gray-800">
            <div className="w-full max-w-md bg-white shadow-xl min-h-screen flex flex-col relative animate-[fadeIn_0.5s_ease-out]">

                {/* 1. 상단 성공 애니메이션 영역 */}
                <div className="bg-blue-600 pt-16 pb-20 px-6 text-center rounded-b-[2.5rem] relative overflow-hidden">
                    {/* 배경 장식 원 (디자인 요소) */}
                    <div className="absolute top-[-20%] left-[-10%] w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>
                    <div className="absolute bottom-[-10%] right-[-10%] w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>

                    <div className="relative z-10 flex flex-col items-center text-white">
                        <div className="bg-white text-blue-600 rounded-full p-4 mb-4 shadow-lg animate-[scaleIn_0.4s_cubic-bezier(0.175,0.885,0.32,1.275)]">
                            <CheckCircle size={48} strokeWidth={3} />
                        </div>
                        <h1 className="text-2xl font-bold mb-2">결제가 완료되었습니다!</h1>
                        <p className="text-blue-100 text-sm">주문하신 쿠폰이 발급되었습니다.<br/>카카오톡에서 확인 가능합니다.</p>
                    </div>
                </div>
{/*

                <div className="px-5 -mt-12 mb-24 relative z-20">
                    <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">

                         영수증 헤더
                        <div className="bg-gray-50 p-5 border-b border-dashed border-gray-200 flex flex-col gap-1">
                            <div className="flex justify-between items-center">
                                <span className="text-xs text-gray-500">주문번호</span>
                                <button onClick={handleCopyOrderId} className="flex items-center gap-1 text-xs text-gray-500 hover:text-blue-600">
                                    {orderInfo.orderId} <Copy size={10} />
                                </button>
                            </div>
                            <div className="flex justify-between items-center">
                                <span className="text-xs text-gray-500">결제일시</span>
                                <span className="text-xs text-gray-800 font-medium">{orderInfo.date}</span>
                            </div>
                        </div>

                        <div className="p-5">
                            <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
                                <Receipt size={16} className="text-gray-400"/> 구매 내역
                            </h3>
                            <ul className="space-y-3 mb-6">
                                {orderInfo.items.map((item, idx) => (
                                    <li key={idx} className="flex justify-between text-sm">
                    <span className="text-gray-600 overflow-hidden text-ellipsis whitespace-nowrap pr-4">
                      {item.name} <span className="text-blue-600 font-bold">x {item.quantity}</span>
                    </span>
                                        <span className="font-bold text-gray-900 flex-shrink-0">
                      {formatPrice(item.price * item.quantity)}원
                    </span>
                                    </li>
                                ))}
                            </ul>

                            <div className="border-t border-gray-100 pt-4 space-y-2">
                                <div className="flex justify-between text-sm text-gray-500">
                                    <span>총 상품금액</span>
                                    <span>{formatPrice(orderInfo.totalAmount)}원</span>
                                </div>
                                {orderInfo.usedPoints > 0 && (
                                    <div className="flex justify-between text-sm text-red-500">
                                        <span>포인트 사용</span>
                                        <span>- {formatPrice(orderInfo.usedPoints)}원</span>
                                    </div>
                                )}
                                <div className="flex justify-between items-end pt-2 mt-2 border-t border-dashed border-gray-200">
                                    <span className="font-bold text-gray-900">최종 결제 금액</span>
                                    <span className="font-bold text-2xl text-blue-600">
                    {formatPrice(orderInfo.finalAmount)}원
                  </span>
                                </div>
                            </div>
                        </div>

                        <div className="bg-gray-50 px-5 py-3 text-xs text-gray-500 flex justify-between">
                            <span>결제 수단</span>
                            <span>{orderInfo.paymentMethod}</span>
                        </div>
                    </div>

                </div>
*/}

                <div className="text-center mt-6 text-gray-400 text-xs">
                    구매하신 쿠폰은 주문내역에서도<br/>확인이 가능합니다.
                </div>
                {/* 3. 하단 고정 버튼 */}
                <div className="fixed bottom-0 w-full max-w-md bg-white border-t border-gray-200 p-4 safe-area-bottom z-30 flex gap-3">
                    <button
                        onClick={() => window.location.href = '/advanced/coupon'} // 메인으로 이동
                        className="flex-1 py-4 rounded-xl text-gray-700 font-bold bg-gray-100 hover:bg-gray-200 transition-colors flex justify-center items-center gap-2"
                    >
                        <Home size={20} /> 홈으로
                    </button>
                </div>

            </div>

            {/* 애니메이션 정의 */}
            <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scaleIn {
          from { transform: scale(0); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>
        </div>
    );
};

export default PaymentSuccessPage;